let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eKxWb")).then(() => parcelRequire('g8q5V'));